import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import axios from 'axios'
import App from './App.vue'
import store from './store'
import router from './router'

// 创建axios实例
const app = createApp(App)

// 全局API基础URL - 根据环境动态设置
const API_BASE_URL = 'https://doufu.rsk.cn'

// 判断当前环境
const isDevelopment = process.env.NODE_ENV === 'development'

const http = axios.create({
  baseURL: API_BASE_URL, // 开发环境用代理，生产环境用完整URL
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: false // 禁用凭证，避免跨域问题
})

// 挂载全局变量
app.config.globalProperties.$apiBaseUrl = API_BASE_URL

// 请求拦截器
http.interceptors.request.use(config => {
  // 动态获取最新的 token
  const token = localStorage.getItem('token') || ''
  if (token) {
    config.headers['token'] = token
  }
  
  // 添加跨域相关headers
  if (!isDevelopment) {
    // 生产环境添加跨域相关headers
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS'
    config.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, token'
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
http.interceptors.response.use(response => {
  return response.data
}, error => {
  // 处理401状态码 - 未授权
  if (error.response && error.response.status === 401) {
    // 清除本地存储的token
    localStorage.removeItem('token')
    // 清除Vuex中的用户信息
    store.dispatch('logout')
    // 跳转到登录页面
    router.push('/login')
    // 显示提示信息
    const message = error.response.data?.msg || '登录已过期，请重新登录'
    // 使用Element Plus的消息提示
    if (typeof window !== 'undefined' && window.ElementPlus) {
      window.ElementPlus.ElMessage.error(message)
    }
    // 返回一个已拒绝的Promise，阻止后续处理
    return Promise.reject(new Error(message))
  }
  return Promise.reject(error)
})

app.use(ElementPlus)
// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store)
app.use(router)

// 挂载axios到Vue实例
app.config.globalProperties.$axios = http

// 禁止F12开发者工具
function disableDevTools() {
  // 监听F12按键
  document.addEventListener('keydown', function(e) {
    if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I') || (e.ctrlKey && e.shiftKey && e.key === 'J') || (e.ctrlKey && e.key === 'U')) {
      e.preventDefault()
      // 清空页面内容
      document.body.innerHTML = ''
      document.body.style.backgroundColor = 'white'
      document.body.style.display = 'flex'
      document.body.style.justifyContent = 'center'
      document.body.style.alignItems = 'center'
      document.body.style.height = '100vh'
      document.body.style.fontSize = '24px'
      document.body.style.color = '#333'
      document.body.textContent = '开发者工具已被禁用'
      return false
    }
  })
  
  // 防止右键菜单
  document.addEventListener('contextmenu', function(e) {
    e.preventDefault()
    return false
  })
  
  // 防止查看源代码
  document.addEventListener('keydown', function(e) {
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault()
      return false
    }
  })
  
  // 检测开发者工具打开状态
  function detectDevTools() {
    const threshold = 160
    const widthThreshold = window.outerWidth - window.innerWidth > threshold
    const heightThreshold = window.outerHeight - window.innerHeight > threshold
    
    if (widthThreshold || heightThreshold) {
      // 清空页面内容
      document.body.innerHTML = ''
      document.body.style.backgroundColor = 'white'
      document.body.style.display = 'flex'
      document.body.style.justifyContent = 'center'
      document.body.style.alignItems = 'center'
      document.body.style.height = '100vh'
      document.body.style.fontSize = '24px'
      document.body.style.color = '#333'
      document.body.textContent = '开发者工具已被禁用'
    }
  }
  
  // 定期检测
  setInterval(detectDevTools, 1000)
}

// 启用开发者工具禁用功能
// disableDevTools()

app.mount('#app')
